// test2348
(2348 && 0);
